export const categories = [
  {
    slug: "film-tv",
    name: "影视剧",
    short: "追剧",
    desc: "新剧开播、剧情走向、大结局讨论，围观群众的第一手观后感都在这儿。",
    icon: "ri-film-line",
    count: 42,
  },
  {
    slug: "variety",
    name: "综艺现场",
    short: "综艺",
    desc: "嘉宾阵容、名场面、录制路透，边看边聊，笑点与争议一起收割。",
    icon: "ri-live-line",
    count: 31,
  },
  {
    slug: "music",
    name: "音乐现场",
    short: "音乐",
    desc: "音乐节、舞台、新歌上线的实时讨论，现场感拉满的瓜田连线。",
    icon: "ri-music-2-line",
    count: 24,
  },
  {
    slug: "fashion",
    name: "时尚造型",
    short: "时尚",
    desc: "红毯造型、品牌联名、穿搭争议，围绕记忆点展开的造型盘点评分。",
    icon: "ri-t-shirt-line",
    count: 19,
  },
  {
    slug: "influencer",
    name: "网红动态",
    short: "网红",
    desc: "内容创作者的新动向、直播间名场面，讨论区实时跟进的热门话题。",
    icon: "ri-smartphone-line",
    count: 27,
  },
  {
    slug: "backstage",
    name: "幕后花絮",
    short: "幕后",
    desc: "拍摄间隙、采访片段、制作侧写，把镜头之外的故事摊开来聊。",
    icon: "ri-movie-2-line",
    count: 15,
  },
];